export default __webpack_public_path__ + "static/media/logo.c8eb1835.svg";